"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreProvider = void 0;
var Error_1 = require("./Error");
var CoreProvider = /** @class */ (function () {
    function CoreProvider() {
    }
    CoreProvider.getDefault = function () {
        if (!this.core) {
            throw new Error_1.CoreError({
                code: Error_1.CoreErrorCode.NOT_INITIALIZED,
                message: 'Default instance of Core is not set',
            });
        }
        return this.core;
    };
    CoreProvider.setDefault = function (core) {
        if (this.core) {
            throw new Error_1.CoreError({
                code: Error_1.CoreErrorCode.ALREADY_INITIALIZED,
                message: 'Default instance of Core is already set',
            });
        }
        this.core = core;
    };
    return CoreProvider;
}());
exports.CoreProvider = CoreProvider;
//# sourceMappingURL=CoreProvider.js.map